import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import React, {Component} from "react";

import {RTPProfilesOrder} from "../../../../reducers/rtpProfiles.reducer";
import {getRTPProfileValue} from "../../../Utils/rtp-profiles";

interface RTPProfilesTableProps {
    defaultProfile: any;
    rows: any[];
    profiles: any[];
    currentOrder: RTPProfilesOrder;
    reorderAction: any;
    changeProfile: any;
}

class RTPProfilesTable extends Component<RTPProfilesTableProps, {}> {
    isDefaultProfile = profile =>
        this.props.defaultProfile &&
        `${profile.id}` === `${this.props.defaultProfile.id}`;

    reorderColumn = key => {
        const direction =
            key === this.props.currentOrder.key &&
            this.props.currentOrder.direction === "asc"
                ? "desc"
                : "asc";
        this.props.reorderAction(key, direction);
    };

    sortIcon = key => {
        if (this.props.currentOrder.key !== key) {
            return null;
        }
        return (
            <span className="material-icons">
                {this.props.currentOrder.direction === "asc"
                    ? "keyboard_arrow_down"
                    : "keyboard_arrow_up"}
            </span>
        );
    };

    render() {
        const profileItems = this.props.profiles.map(profile => ({
            value: getRTPProfileValue(profile),
            label: (
                <span
                    className={`rtp-profile-option ${
                        this.isDefaultProfile(profile) ? "default" : ""
                    }`}
                >
                    {profile.full_profile || profile.rtp || `${profile.id}`}
                    {this.isDefaultProfile(profile) && (
                        <span className="default-label">Default</span>
                    )}
                </span>
            )
        }));

        return (
            <table id="table-rtp-profiles">
                <thead>
                    <tr>
                        <th onClick={() => this.reorderColumn("description")}>
                            <div>Games {this.sortIcon("description")}</div>
                        </th>
                        <th onClick={() => this.reorderColumn("profile")}>
                            <div>RTP Profile {this.sortIcon("profile")}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.rows.map(row => (
                        <tr key={row.identifier}>
                            <td>{row.description}</td>
                            <td>
                                {row.profile !== row.originalProfile && (
                                    <span className="changed" />
                                )}
                                <Components.SelectMenu
                                    items={profileItems}
                                    noValueLabel="RTP Profile"
                                    value={row.profile}
                                    onChange={profile =>
                                        this.props.changeProfile(
                                            row.identifier,
                                            profile
                                        )
                                    }
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}

export default RTPProfilesTable;
